import React, { useEffect, useState, useRef } from 'react';
import {
    Container,
    Box,
    Avatar,
    Typography,
    Grid,
    TextField,
    Button,
    Paper,
    Chip,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    ListItemButton,
    Snackbar,
} from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import { Grid2 } from '@mui/material';
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";
import { Link, Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
const UserList = () => {
    let navigate = useNavigate();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });
    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();
    const [userList, setUserList] = useState([]); //골프장

    useEffect(() => {
        actions.extendTime(userData);
//        console.log("userData :" + JSON.stringify(userData))
        getUserList()
    }, [userData]);


    
    const getUserList = async () => {
        if (!userData || !userData.userLevel) {
            return null;
        }

        if (userData.userLevel < 50) {
            return null;
        }

        try {

            const reqData = {};
            reqData.userEmail = userData.userEmail;
            reqData.userPhone = userData.userPhone;


            let response = await axios.post("/api/booking/GetUserList", reqData);
            console.log("getUserList result :" + JSON.stringify(response.data))
            if ((response.data.code === 0)) {

                setUserList(response.data.result)
            }
        } catch (err) {
            console.error(err);
        }

    }


    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg) => {
        setMessageSnackbar(msg);
        setStateSnackBar({ ...stateSnackBar, openSnackBar: true })
    }


    const handleListItemClick = (item) => {
        console.log("user list click :" + JSON.stringify(item))
        navigate("/userInfo", { state: { userItem: item } })
    }


    return (
        <Container maxWidth="md" sx={{ mt: 1, mb: 5 }}>
            <Paper elevation={3} sx={{ p: 1 }}>
                <List sx={{ width: '100%', bgcolor: 'background.paper', }}>
                    {userList.map((userItem) => (
                        <ListItem key={userItem.userEmail} divider
                            secondaryAction={
                                <IconButton aria-label="관리"
                                    onClick={(event) => handleListItemClick(userItem)}
                                
                                >
                                    <ManageAccountsIcon />
                                </IconButton>
                            }
                        >
                            <ListItemButton
                                onClick={(event) => handleListItemClick(userItem)}
                            >
                                <ListItemText
                                    primary={userItem.userName}
                                    secondary={userItem.userEmail}
                                />

                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>                
            </Paper>
            <Snackbar
                anchorOrigin={{ vertical: verticalSnackBar, horizontal: horizontalSnackBar }}
                open={openSnackBar}
                onClose={handleSnackBarClose}
                message={messageSnackBar}
                key={verticalSnackBar + horizontalSnackBar}
                autoHideDuration={5000}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleSnackBarClose}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            />
        </Container>

    )
}
export default UserList;